var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_18027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5465 1.03725C11.8397 0.103465 13.1613 0.103467 13.4545 1.03726L15.536 7.66415C15.6669 8.08093 16.0532 8.3645 16.49 8.3645H23.2959C24.2564 8.3645 24.6645 9.5868 23.8967 10.1639L18.333 14.3456C17.9943 14.6002 17.8528 15.0405 17.9797 15.4447L20.091 22.1666C20.3823 23.0939 19.3132 23.8497 18.5362 23.2657L13.1013 19.1809C12.7454 18.9134 12.2556 18.9134 11.8997 19.1809L6.46481 23.2657C5.68782 23.8497 4.61868 23.0939 4.90994 22.1666L7.02124 15.4447C7.14819 15.0405 7.00667 14.6002 6.66801 14.3456L1.10425 10.1639C0.336441 9.5868 0.74457 8.3645 1.70507 8.3645H8.51095C8.9478 8.3645 9.33409 8.08093 9.465 7.66415L11.5465 1.03725Z",
    fill: "#B6B6B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_18027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.39437602aa54cdfde1fa94016f50f788.svg";
export { ForwardRef as ReactComponent };